import React, { Component } from 'react'
import PropTypes from 'prop-types'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class Logo extends Component {
    static propTypes = {
        openDialog: PropTypes.func.isRequired,
        productId: PropTypes.string.isRequired,
    }

    onClickHandler = () => {
        const { openDialog } = this.props

        openDialog('about')
    }

    render() {
        const { productId } = this.props

        return <div className={`logo type-${productId}`} onClick={this.onClickHandler} />
    }
}
